import PropTypes from 'prop-types'
import React from 'react'

import * as styles from './styles'

class InputPlaceholder extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.bindHandlers()
  }

  bindHandlers() {
    this.handleClick = this.handleClick.bind(this)
    this.handleMouseDown = this.handleMouseDown.bind(this)
  }

  handleClick() {
    // Click 'through' the placeholder to the input
    // for browsers that don't support pointerEvents CSS
    this.props.inputRef.current.focus()
  }

  handleMouseDown(e) {
    // Disable mouseDown events so you can't highlight the placeholder text
    // for browsers that don't support pointerEvents CSS
    e.preventDefault()
  }

  render() {
    return (
      <div
        onClick={this.handleClick}
        onMouseDown={this.handleMouseDown}
        css={styles.placeholder(this.props.subLabel)}
      >
        {this.props.placeholder}
      </div>
    )
  }
}

InputPlaceholder.propTypes = {
  inputRef: PropTypes.object.isRequired,
  placeholder: PropTypes.string.isRequired,
  subLabel: PropTypes.string
}

export default InputPlaceholder
